import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const SearchBar = ({ onSearch }) => {
  const [query, setQuery] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch?.(query);
  };

  const handleClear = () => {
    setQuery('');
    onSearch?.('');
  };

  return (
    <div className="bg-white rounded-2xl shadow-soft border border-accent-100 p-6">
      <h3 className="font-heading font-semibold text-lg text-accent-800 mb-4">
        Search Articles
      </h3>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="relative">
          <Icon 
            name="Search" 
            size={20} 
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-accent-400" 
          />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search gift ideas..."
            className="w-full pl-10 pr-10 py-3 bg-surface border border-accent-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          />
          {query && (
            <button
              type="button"
              onClick={handleClear}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-accent-400 hover:text-accent-600"
            >
              <Icon name="X" size={20} />
            </button>
          )}
        </div>
      </form>

      {/* Quick Suggestions */}
      <div className="mt-4">
        <p className="text-sm text-accent-600 mb-2">Popular searches:</p>
        <div className="flex flex-wrap gap-2">
          {['16 year old', 'mom birthday', 'budget gifts', 'anniversary'].map(suggestion => (
            <button
              key={suggestion}
              onClick={() => {
                setQuery(suggestion);
                onSearch?.(suggestion);
              }}
              className="px-3 py-1 text-xs bg-accent-100 text-accent-700 rounded-full hover:bg-accent-200 transition-colors"
            >
              {suggestion}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchBar;